var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAttendanceExempt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 0H2C0.897 0 0 0.897 0 2V16C0 17.103 0.897 18 2 18H10C10.1313 18.0002 10.2614 17.9744 10.3828 17.9241C10.5041 17.8738 10.6143 17.8 10.707 17.707L17.707 10.707C17.7892 10.6217 17.8556 10.5225 17.903 10.414C17.917 10.384 17.925 10.353 17.936 10.321C17.9645 10.2373 17.9816 10.1502 17.987 10.062C17.989 10.041 18 10.021 18 10V2C18 0.897 17.103 0 16 0ZM2 2H16V9H10C9.73478 9 9.48043 9.10536 9.29289 9.29289C9.10536 9.48043 9 9.73478 9 10V16H2V2ZM11 14.586V11H14.586L11 14.586Z",
    fill: "#3598D0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttendanceExempt);
export default __webpack_public_path__ + "static/media/attendance_exempt.0fae78309db5943ccaa059396be2ffff.svg";
export { ForwardRef as ReactComponent };